import React from "react";

interface Props {
  classification: string | undefined;
}
const NetworkThreatHeaderClassification: React.FC<Props> = ({
  classification
}) => (
  <div
    className={`network-threat-intel__main-header__classification network-threat-intel__main-header__classification--${classification}`}
  >
    {classification}
  </div>
);

export default NetworkThreatHeaderClassification;
